import { executePostRequest } from "@api/client";
import { apiPath } from "@routes/api";

export const postContacts = async (data: any, lang: string) => {
  const [promise] = executePostRequest(apiPath.contacts, data, lang);
  const result: any = await promise;
  return result.data;
};
